var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.832031 7.20833H24.1654M9.58203 13.0417V21.7917M15.4154 13.0417V21.7917M2.29036 7.20833L3.7487 24.7083C3.7487 25.4819 4.05599 26.2237 4.60297 26.7707C5.14995 27.3177 5.89182 27.625 6.66536 27.625H18.332C19.1056 27.625 19.8474 27.3177 20.3944 26.7707C20.9414 26.2237 21.2487 25.4819 21.2487 24.7083L22.707 7.20833M8.1237 7.20833V2.83333C8.1237 2.44656 8.27734 2.07563 8.55083 1.80214C8.82432 1.52865 9.19526 1.375 9.58203 1.375H15.4154C15.8021 1.375 16.1731 1.52865 16.4466 1.80214C16.7201 2.07563 16.8737 2.44656 16.8737 2.83333V7.20833",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.6565657ad6af3bd6f409427d35f23ae1.svg";
export { ForwardRef as ReactComponent };